"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../../../utils/common");
class Helper {
    constructor(chatListRef) {
        this.chatListRef = null;
        this.initialTop = null;
        this.token = null;
        this.calculateParentWrapperHeight = () => {
            var _a;
            const messageInputWrapperHeight = (_a = document.getElementsByClassName("message-field-wrapper")[0]) === null || _a === void 0 ? void 0 : _a.clientHeight;
            const chatHeaderHeight = document.getElementsByClassName("single-chat-header")[0].clientHeight;
            let messagesHeight = window.innerHeight - messageInputWrapperHeight - chatHeaderHeight - 20;
            window.innerWidth >= 767 ? messagesHeight -= 80 : null;
            this.chatListRef.current.style.height = `${messagesHeight}px`;
        };
        this.scrollEvent = (e) => {
            if (!this.initialTop)
                this.initialTop = e.target.scrollTop;
            //@ts-ignore
            if (document.activeElement && document.activeElement.id === 'message-text-input') {
                //@ts-ignore
                if (this.initialTop - e.target.scrollTop >= 100) {
                    //@ts-ignore
                    document.activeElement.blur();
                    if (!common_1.isMobileBrowser().check) {
                        setTimeout(() => {
                            this.calculateParentWrapperHeight();
                        }, 100);
                    }
                }
            }
        };
        this.inputBlur = (e) => {
            if (common_1.ifMobile() || common_1.isMobileBrowser().check) {
                const mainElem = document.getElementById('apc-messages-list');
                mainElem.style.top = '';
                mainElem.style.position = '';
                this.initialTop = null;
                if (common_1.ifMobile()) {
                    this.chatListRef.current.scrollTo(0, mainElem.scrollHeight);
                    this.manipulateInputForIPhoneX('0 0 40px 0');
                }
                this.chatListRef.current.removeEventListener('scroll', this.scrollEvent, false);
            }
        };
        this.triggerChatContainerScroll = (action) => {
            if (common_1.ifMobile()) {
                const mainElem = document.querySelector('.message-parent');
                const pageWrapper = document.getElementById('page_wrapper');
                if (mainElem) {
                    //@ts-ignore
                    mainElem.style.overflow = action ? 'hidden' : '';
                }
                if (pageWrapper) {
                    if (action) {
                        pageWrapper.style.overflow = 'hidden';
                    }
                    else {
                        pageWrapper.style.overflow = '';
                        pageWrapper.style.overflowY = 'scroll';
                    }
                }
            }
        };
        this.chatListRef = chatListRef;
        this.token = localStorage.getItem('token');
    }
    manipulateInputForIPhoneX(style) {
        if (common_1.isIphoneX()) {
            const messageInputWrapper = document.getElementsByClassName("message-field-wrapper")[0];
            if (messageInputWrapper) {
                //@ts-ignore
                messageInputWrapper.style.padding = style;
            }
        }
    }
    prepareContent() {
        const contentContainer = document.querySelector('.logged .content-container');
        const pageWrapper = document.querySelector('#page_wrapper');
        const mobileFooter = document.querySelector('.mobile-footer');
        pageWrapper.classList.add('overflow-y-hidden');
        document.body.classList.add('overflow-y-hidden');
        if (window.innerWidth <= 769) {
            document.body.classList.remove('overflow-y-hidden');
            contentContainer.classList.add('v2-mb-0');
            pageWrapper.classList.add('page-wrapper-for-chat');
            mobileFooter.classList.add('hidden');
        }
        this.manipulateInputForIPhoneX('0 0 40px 0');
    }
    scrollToBottom() {
        this.chatListRef.current.scrollTop = this.chatListRef.current.scrollHeight - this.chatListRef.current.clientHeight;
    }
    triggerBodyFix(action) {
        if (common_1.ifMobile() || common_1.isMobileBrowser().check) {
            if (action) {
                document.body.style.position = 'fixed';
                document.body.style.overflow = 'hidden';
                document.body.style.height = '100%';
                document.body.style.width = '100%';
                // @ts-ignore
                document.querySelector('.content-container').style.paddingBottom = '125px';
                if (common_1.ifMobile()) {
                    //@ts-ignore
                    const mainElem = document.getElementById('apc-messages-list');
                    if (mainElem) {
                        mainElem.style.height = '100%';
                    }
                }
            }
            else {
                document.body.style.position = '';
                document.body.style.overflow = '';
                document.body.style.height = '';
                document.body.style.width = '';
                // @ts-ignore
                document.querySelector('.content-container').style.paddingBottom = '0';
                if (common_1.ifMobile()) {
                    //@ts-ignore
                    const mainElem = document.getElementById('apc-messages-list');
                    if (mainElem) {
                        mainElem.style.height = '';
                    }
                }
            }
        }
    }
    updateCaseInfoHeightOnMobile(action) {
        if (common_1.isMobileBrowser().check) {
            const elem = document.getElementsByClassName("case-details-container")[0];
            if (action) {
                //@ts-ignore
                const elemHeight = elem.offsetHeight;
                //@ts-ignore
                elem.style.height = `${window.innerHeight}px`;
                elem.style.overflowY = 'scroll';
                document.body.style.backgroundColor = '#fff';
                document.body.style.overflowY = 'hidden';
            }
            else {
                //@ts-ignore
                elem.style.height = '';
                document.body.style.backgroundColor = '#f5f6fa';
            }
        }
        if (common_1.ifMobile()) {
            const pageWrapper = document.querySelector('#page_wrapper');
            pageWrapper.style.height = action ? `${window.innerHeight - 50}px` : '';
        }
    }
    deregister(ignoreFooter = false) {
        const contentContainer = document.querySelector('.logged .content-container');
        const pageWrapper = document.querySelector('#page_wrapper');
        const mobileFooter = document.querySelector('.mobile-footer');
        pageWrapper.classList.remove('overflow-y-hidden');
        if (window.innerWidth <= 769) {
            contentContainer.classList.remove('v2-mb-0');
            pageWrapper.classList.remove('page-wrapper-for-chat');
            if (!ignoreFooter) {
                mobileFooter.classList.remove('hidden');
            }
        }
        this.manipulateInputForIPhoneX('');
    }
    inputFocus(e) {
        if (common_1.ifMobile() || common_1.isMobileBrowser().check) {
            const mainElem = document.getElementById('apc-messages-list');
            this.initialTop = null;
            this.chatListRef.current.addEventListener('scroll', this.scrollEvent, false);
            if (common_1.ifMobile()) {
                setTimeout(() => {
                    const windowOffset = window.pageYOffset;
                    mainElem.style.top = `-${windowOffset - 80}px`;
                    mainElem.style.position = 'relative';
                }, 100);
                this.manipulateInputForIPhoneX('0 0 10px 0');
            }
        }
    }
    downloadFile(el) {
        if (el.preview)
            return;
        const url = common_1.isImage(el.type) ? this.generateImageFullUrl(el) : this.generateFileUrl(el);
        //@ts-ignore
        if (common_1.ifMobile()) {
            //@ts-ignore
            cordova.InAppBrowser.open(url, '_system', 'location=no');
        }
        else {
            const link = document.createElement('a');
            document.body.appendChild(link);
            link.href = url;
            link.download = el.name;
            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            document.body.removeChild(link);
        }
    }
    generatePreviewUrl(el) {
        //since i don't know why we are storing attachment full url.
        //doing small workround for replace url with api
        const url = common_1.covertUrl(el);
        return `${el.preview || `${url}?w=140&h=140&token=${this.token}`}`;
    }
    generateImageFullUrl(el) {
        const url = common_1.covertUrl(el);
        return `${url}?token=${this.token}&originName=${el.name}`;
    }
    generateFileUrl(el) {
        const url = common_1.covertUrl(el);
        return `${url}?originName=${el.name}&token=${this.token}`;
    }
}
exports.default = Helper;
